import { render, staticRenderFns } from "./CS-tab.vue?vue&type=template&id=1a003dd2"
import script from "./CS-tab.vue?vue&type=script&lang=js"
export * from "./CS-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports